import React from 'react'

export const FaqSchema = () => {
    const faqData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "What is a trademark search, and why is it important for startups?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "A trademark search checks if your desired brand name, logo, or tagline is already registered or applied for. It helps startups avoid legal issues, branding conflicts, and costly rebranding after launch."
                }
            },
            {
                "@type": "Question",
                "name": "Is the trademark search really free with Website Drona?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, Website Drona offers a 100% free preliminary trademark search with every website development or digital marketing project. There are no hidden charges or obligations."
                }
            },
            {
                "@type": "Question",
                "name": "What information do I need to provide for a trademark search?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You just need to share your brand name, logo idea, or tagline. Website Drona will run a basic availability check through the official Indian Trademark Registry database."
                }
            },
            {
                "@type": "Question",
                "name": "Can I trademark my brand name before launching the website?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, it is highly recommended to trademark your name before launching. This protects your brand identity and helps avoid legal complications later."
                }
            },
            {
                "@type": "Question",
                "name": "What happens if my brand name is already taken?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "If your desired name is already registered, Website Drona will help you explore alternatives and guide you on choosing a trademark-safe name that fits your vision."
                }
            },
            {
                "@type": "Question",
                "name": "Is this trademark search valid for all of India?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, Website Drona conducts searches through the official Indian Trademark Registry, making results valid across India for all trademark classes."
                }
            }
        ]
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(faqData) }}
        />
    );
}


export const Servicetype = () => {
    const serviceSchema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Free Trademark Search",
        "provider": {
            "@type": "Organization",
            "name": "Website Drona",
            "url": "https://www.websitedrona.com/",
            "logo": "https://www.websitedrona.com/images/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-9312765435",
                "contactType": "customer service",
                "areaServed": "IN"
            }
        },
        "areaServed": {
            "@type": "Country",
            "name": "India"
        },
        "description": "Website Drona offers a free preliminary trademark search in India to help startups and businesses secure their brand name, logo, or slogan before launch."
    };
    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
            />
        </>
    )
}

export const Howschema = () => {
    const howToSchema = {
        "@context": "https://schema.org",
        "@type": "HowTo",
        "name": "How to Get a Free Trademark Search with Website Drona",
        "description": "Step-by-step guide to checking trademark availability for your brand name, logo, or tagline in India with Website Drona.",
        "step": [
            {
                "@type": "HowToStep",
                "name": "Share Your Brand Details",
                "text": "Provide your brand name, tagline, or logo concept."
            },
            {
                "@type": "HowToStep",
                "name": "Trademark Registry Check",
                "text": "We run a trademark availability check with the Indian Trademark Registry."
            },
            {
                "@type": "HowToStep",
                "name": "Get Results",
                "text": "Receive clarity on your brand’s legal availability before investing in domains, ads, or design."
            }
        ]
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(howToSchema) }}
        />
    );
}